import { SearchOutlined, PlusCircleOutlined, CloseCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, HddOutlined, EditOutlined, FileExcelOutlined } from '@ant-design/icons';
import { DatePicker, Form, InputRef, Tag } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import { useHistory } from "react-router-dom";
import React, { useRef, useState, useEffect } from 'react';
import style from './Tables.module.scss'
import { getAllGeiInventoryTable, postResgisterGeiInventor, putResgisterGeiInventory, getGeiInventoryById, getAlLGeiInventoryTableByUser, deleteGeiInventoryById } from '../../../store/geiInventory/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateYear4, validate100 } from '../../../globals/Inputs/validateInput';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { typesIdentification, typesReportFrequency, typesReportUse, typesoGeiLimits, typesoOperationalsLimits, typesoOrganizationalLimits } from '../../../globals/Parameters/listParameters';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../store/organization/types';
import { openNotification } from '../../../globals/Components/Notification/Notificaction';
import TextArea from 'antd/es/input/TextArea';
import { getAllOrganization } from '../../../store/organization/thunks';
import { GeiInventory } from '../../../store/geiInventory/types';
import { UserState } from '../../../store/user/types';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { getUserByToken } from '../../../store/user/thunks';
import * as XLSX from 'xlsx';
import dayjs, { Dayjs } from 'dayjs';


interface UserTableProps {
    getAllGeiInventoryTable?: any;
    postResgisterGeiInventor?: any;
    putResgisterGeiInventory?: any;
    getAllOrganization?: any;
    getGeiInventoryById?: any;
    user: UserState;
    getAlLGeiInventoryTableByUser?: any;
    getUserByToken?: any;
    deleteGeiInventoryById?: any;
}

interface DataType {
    key: string;
    id: string;
    MsIdentity_organization_id: string;
    MsIdentity_organization_ruc: string;
    organization: string;
    code: string;
    year: number;
    person_charge: string;
    covered_start: string;
    covered_finish: string;
    report_frequency: string;
    expected_use: string;
    organizational_limits: string;
    status: string;
    description: string;
    created_at: string;
    updated_at: string;
    msidentityOrganizationName: string;
}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TGeiInventory: React.FC<UserTableProps> = (props: UserTableProps) => {
    const dateFormat = 'DD-MM-YYYY';
    const [form] = Form.useForm();
    const [formValidate] = Form.useForm();
    const history = useHistory();
    const [dataTable, setDataTable] = useState<DataType[]>([]);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const { Option } = Select;
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [userData, setUserData] = useState<DataType>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');

    const [typeFrequency, setTypeFrequency] = useState("");
    const [typeUse, setTypeUse] = useState<string[]>([]);
    const [typeOrganizationals, setTypeOrganizationals] = useState("");
    const [typeOperationals, setTypeOperationals] = useState("");
    const [typeGei, setTypeGei] = useState("");
    const [typeOrganization, setTypeOrganization] = useState("");

    const [geiId, setGeiId] = useState("")
    const [organization, setOrganization] = useState([]);
    const [pagasize, setPageSize] = useState(5);

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: pagasize,
    });
    const handleExportToExcel = () => {
        const exportData = dataTable.map(item => ({
            'Código': item.code,
            'Año de reporte': item.year,
            'Persona responsable del reporte': item.person_charge,
            'Periodo inicio': item.covered_start,
            'Periodo final': item.covered_finish,
            'Frecuencia reporte': item.report_frequency,
            'Uso previsto': item.expected_use,
            'Límites organizacionales': item.organizational_limits,
            'Descripción': item.description,
            'Creado': item.created_at,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Inventario_GEI');

        const excelFileName = 'inventario_gei.xlsx';
        XLSX.writeFile(wb, excelFileName);

        openNotification("Exportación exitosa", `Los datos se han exportado a ${excelFileName}`);
    };
    const handleTableChange = async (pagination: TablePaginationConfig) => {
        setPagination({ ...pagination });
        if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
            const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, "NULL");
            setDataTable(responseData.geiInventoryTable);
        } else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
            const responseData = await props.getAlLGeiInventoryTableByUser(pagination.current, pagination.pageSize, "NULL");
            setDataTable(responseData.geiInventoryTable);
        }


    };

    const init = async () => {        
        const rol = await props.getUserByToken();
            const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, "NULL");
            setPagination({
                current: 1,
                pageSize: pagasize,
                total: responseData.totalTable
            })
            const responseDataOrganization = await props.getAllOrganization();
            setOrganization(responseDataOrganization);
            setDataTable(responseData.geiInventoryTable);
    }

    useEffect(() => {
        init();
    }, []);


    const handleSearch = async (
        selectedKeys: string[]
    ) => {
        if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
            const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, selectedKeys.length > 0 ? selectedKeys[0] : "NULL");
            setDataTable(responseData.geiInventoryTable);
        } else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
            const responseData = await props.getAlLGeiInventoryTableByUser(pagination.current, pagination.pageSize, selectedKeys.length > 0 ? selectedKeys[0] : "NULL");
            setDataTable(responseData.geiInventoryTable);
        }

    };

    const handleReset = async (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
            const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, "NULL");
            setDataTable(responseData.geiInventoryTable);
        } else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
            const responseData = await props.getAlLGeiInventoryTableByUser(pagination.current, pagination.pageSize, "NULL");
            setDataTable(responseData.geiInventoryTable);
        }
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[])}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[])}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>

                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const newActionTye: ColumnType<DataType> = {
        title: 'Organización',
        width: 220,
        dataIndex: 'msidentityOrganizationName',
        key: 'msidentityOrganizationName',
        // ...getColumnSearchProps('year', 'año'),
    };
    const columnsType: ColumnsType<DataType> = [
        {
            title: 'Año de reporte',
            width: 100,
            dataIndex: 'year',
            key: 'year',
            filterMode: 'tree',
            ...getColumnSearchProps('year', 'año'),
        },

        {
            title: 'Persona responsable del reporte',
            dataIndex: 'personCharge',
            key: 'personCharge',
            width: 250,
        },
        {
            title: 'Periodo inicio',
            dataIndex: 'coveredStart',
            key: 'coveredStart',
            width: 120,
             render: (date: string) => date ? dayjs(date).format('DD/MM/YYYY') : 'Sin fecha',
        },
        {
            title: 'Periodo final',
            dataIndex: 'coveredFinish',
            key: 'coveredFinish',
            width: 120,
             render: (date: string) => date ? dayjs(date).format('DD/MM/YYYY') : 'Sin fecha',
        },

        {
            title: 'Frecuencia reporte',
            dataIndex: 'reportFrequency',
            key: 'reportFrequency',
            width: 150,

        },
        {
            title: 'Uso previsto',
            dataIndex: 'expectedUse',
            key: 'expectedUse',
            width: 250,

        },
        {
            title: 'Límites organizacionales',
            dataIndex: 'organizationalLimits',
            key: 'organizationalLimits',
            width: 200,
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 120,
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            key: 'description',
            width: 250,
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 110,
        },
    ];

    const newAction: ColumnType<DataType> = {
        title: 'Acción',
        key: 'operation',
        fixed: 'right',
        width: 130,

        render: (record: DataType) => (
            <Space size="middle">
                <Button
                    type="text"
                    className={style["update-button"]}
                    onClick={() => history.push("/establishment/gei/" + record.id)}
                    icon={<HddOutlined />}
                >
                </Button>
                <Button
                    type="text"
                    className={style["update-button"]}
                    onClick={() => showModalUpdate(record.id)}
                    icon={<EditOutlined />}
                />
                <Button
                    type="text"
                    className={style["eliminate-button"]}
                    onClick={() => handleTypeDeleteButton(record.id)}
                    icon={<CloseCircleOutlined />}
                />
            </Space>
        ),
    };

    const adminColumns: ColumnsType<DataType> = [
        ...[newActionTye],
        ...columnsType,
        ...[newAction],
    ];
    const clientColumns: ColumnsType<DataType> = [
        ...[newActionTye],
        ...columnsType,
        ...[newAction],
    ];

    const handleOk = () => {

        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };






    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = () => {
        form.resetFields();
        setIsFormValidate(true);
        setIsModalOpen(true);
        setTypeModal(true);

    };
    const showModalUpdate = async (value: String) => {
        form.resetFields();
        const responseData: GeiInventory = await props.getGeiInventoryById(value);
        setGeiId(responseData.id);
        let formattedDate: Dayjs | null = null;
        let formattedDateEnd: Dayjs | null = null;

        if (typeof responseData.coveredStart === 'string') {
            formattedDate = dayjs(responseData.coveredStart);
        } else if (typeof responseData.coveredStart === 'object') {
            const { year, month, day } = responseData.coveredStart;
            formattedDate = dayjs(`${year}-${month}-${day}`, 'YYYY-M-D');
        }
        if (typeof responseData.coveredFinish === 'string') {
            formattedDateEnd = dayjs(responseData.coveredFinish);
        } else if (typeof responseData.coveredFinish === 'object') {
            const { year, month, day } = responseData.coveredFinish;
            formattedDateEnd = dayjs(`${year}-${month}-${day}`, 'YYYY-M-D');
        }

        form.setFieldsValue({
            code: responseData.code,
            organization: responseData.msIdentity_organization_id,
            year: responseData.year,
            person: responseData.personCharge,
            coveredStart: formattedDate,
            coveredFinish: formattedDateEnd,
            reportFrequency: responseData.reportFrequency,
            expectedUse: responseData.expectedUse,
            description: responseData.description,
            organizationalLimits: responseData.organizationalLimits,

        });

        setIsModalOpen(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };

    const getRucByOrganizationId = (id: string, organizations: Organization[]): string | undefined => {
        const org = organizations.find(organization => organization.id === id); // Busca la organización por id
        return org ? org.ruc : undefined; // Si la organización existe, retorna el RUC, sino undefined
    };

    const onFinish = async (values: any) => {
        if (values.code == undefined) {
            values.code = "A";
        }

        const register = {
            id: values.id,
            MsIdentity_organization_id: values.organization,
            year: values.year,
            personCharge: values.person,
            coveredStart: values.coveredStart.format("YYYY-MM-DD"),
            coveredFinish: values.coveredFinish.format("YYYY-MM-DD"),
            reportFrequency: values.reportFrequency,
            expectedUse: values.expectedUse,
            description: values.description == undefined ? ' ' : values.description,
            organizationalLimits: values.organizationalLimits,
            MsIdentity_organization_ruc: getRucByOrganizationId(values.organization, organization)

        };
        handleCancel();
        if (typeModal) {
            await props.postResgisterGeiInventor(register);
        } else {
            register.id = geiId;
            await props.putResgisterGeiInventory(register);
        }
        const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, "NULL");
        setDataTable(responseData.geiInventoryTable);
        form.resetFields();
        formValidate.resetFields();

    };

    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");
    const handleDeleteMethodOk = async () => {
        const responseDataDelete = await props.deleteGeiInventoryById(isIdData);
        if (responseDataDelete != undefined) {
            const responseData = await props.getAllGeiInventoryTable(pagination.current, pagination.pageSize, "NULL");
            setDataTable(responseData.geiInventoryTable);
        }
        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={showModalCreate}
            >
                Crear inventario GEI
            </Button>

            <Button
                type="primary"
                icon={<FileExcelOutlined />}
                style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                onClick={handleExportToExcel}
            >
                Exportar a Excel
            </Button>
            <Drawer title={typeModal ? "Crear un nuevo inventario GEI" : "Actualizar inventario GEI"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                {/* Resto del código del Drawer */}
            </Drawer>
            <Table size="small" columns={props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190" ? adminColumns : clientColumns} dataSource={dataTable} scroll={{ x: 1500 }} pagination={pagination}
                onChange={handleTableChange} />
            <Drawer title={typeModal ? "Crear un nuevo inventario GEI" : "Actualizar inventario GEI"} open={isModalOpen} onClose={handleCancel} width={350} footer={null}>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >

                    <Form.Item label="Organización" name="organization" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: string) => setTypeOrganization(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={typeOrganization}
                            placeholder="Escoga la organización"
                        >
                            {organization.map((type: Organization) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.ruc + "-" + type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Año de reporte" name="year" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateYear4(value) }]}>
                        <Input placeholder="Ingresar año" />
                    </Form.Item>

                    <Form.Item name="person" label="Persona a cargo" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Input placeholder="Ingresar persona a cargo" />
                    </Form.Item>

                    <Form.Item label="Periodo cubierto del inventario" name="coveredStart" rules={[{ required: true, message: validateMessages.emptyField },]}>
                        <DatePicker locale={locale} format={dateFormat} className={style["user-input-datepiker"]} placeholder="Ingresar inicio" />
                    </Form.Item>
                    <Form.Item label="" name="coveredFinish" rules={[{ required: true, message: validateMessages.emptyField },]}>
                        <DatePicker locale={locale} format={dateFormat} className={style["user-input-datepiker"]} placeholder="Ingresar fin" />
                    </Form.Item>

                    <Form.Item label="Frecuencia reporte" name="reportFrequency" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            style={{ width: "100%" }}
                            onChange={(type: string) => setTypeFrequency(type)}
                            value={typeFrequency}
                            placeholder="Escoga una frecuencia"
                        >
                            {typesReportFrequency.map((type) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.value}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Uso previsto" name="expectedUse" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            mode='multiple'
                            style={{ width: "100%" }}
                            onChange={(type: string[]) => setTypeUse(type)}
                            value={typeUse}
                            //defaultValue={['USO INTERNO', 'DIVULGACIÓN PÚBLICA']}
                            placeholder="Escoga un uso"
                        >
                            {typesReportUse.map((type) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.value}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Límites organizacionales" name="organizationalLimits" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            style={{ width: "100%" }}
                            onChange={(type: string) => setTypeOrganizationals(type)}
                            value={typeOrganizationals}
                            placeholder="Escoga un límite"
                        >
                            {typesoOrganizationalLimits.map((type) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.value}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="description" label="Descripción" >

                        <TextArea placeholder="Ingresar descripción" rows={4} />
                    </Form.Item>


                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>

            </Drawer>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar el Inventario GEI? </h3>
            </Modal>
        </>
    );
};

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {
    getAllGeiInventoryTable, postResgisterGeiInventor, getUserByToken, deleteGeiInventoryById, putResgisterGeiInventory, getAllOrganization, getGeiInventoryById, getAlLGeiInventoryTableByUser
})(TGeiInventory);